<template>
	<div class="nav">
		<!--大屏幕-->
		<el-menu :default-active="curActiveIndex" class="navMenu el-menu-demo" mode="horizontal" active-text-color="#253b55">
			<el-menu-item index="0" class="menuLogo">
				<a href="index.html">
					<el-image class="navLogoImg" :src="baseImgUrl + logoImg"></el-image>
				</a>
			</el-menu-item>
			<div class="flex-grow" />
			<el-menu-item index="1"><a class="aLevelOne" href="index.html">Home</a></el-menu-item>
			<el-submenu index="2">
				<template slot="title">About</template>
				<el-menu-item index="2-1"><a class="aLevelTwo" href="about.html#/intro">Company Profile</a></el-menu-item>

				<el-submenu index="2-2">
					<template slot="title"><div class="tit">Organizational Structure</div></template>
					<el-menu-item index="2-6-1"><a class="aLevelThree" href="about.html#/org/frame">Company structure</a></el-menu-item>
					<el-menu-item index="2-6-2"><a class="aLevelThree" href="about.html#/org/leader">Leadership</a></el-menu-item>
				</el-submenu>

				<el-menu-item index="2-4"><a class="aLevelTwo" href="about.html#/business">Main Business</a></el-menu-item>
				<el-menu-item index="2-5"><a class="aLevelTwo" href="about.html#/honor">Qualifications and Honors</a></el-menu-item>
				<el-submenu index="2-6">
					<template slot="title"><div class="tit">Corporate Culture</div></template>
					<el-menu-item index="2-6-1"><a class="aLevelThree" href="about.html#/culture/slogan">Company Slogan</a></el-menu-item>
					<el-menu-item index="2-6-2"><a class="aLevelThree" href="about.html#/culture/staff">Staff Presence</a></el-menu-item>
					<el-menu-item index="2-6-3"><a class="aLevelThree" href="about.html#/culture/office">Corporate Environment</a></el-menu-item>
					<el-menu-item index="2-6-4"><a class="aLevelThree" href="about.html#/culture/video">Video Collection</a></el-menu-item>
				</el-submenu>
				<el-submenu index="2-7">
					<template slot="title"><div class="tit">Affiliated Agency</div></template>
					<el-menu-item index="2-7-1"><a class="aLevelThree" href="about.html#/branch/singapore">Companies based in Singapore</a></el-menu-item>
					<el-menu-item index="2-7-2"><a class="aLevelThree" href="about.html#/branch/maritime">Global Maritime</a></el-menu-item>
					<el-menu-item index="2-7-3"><a class="aLevelThree" href="about.html#/branch/equip">Global Equipment</a></el-menu-item>
				</el-submenu>
			</el-submenu>
			<el-submenu index="3">
				<template slot="title">Resources</template>
				<el-menu-item index="3-1"><a class="aLevelTwo" href="resource.html#/ship">Vessel Resources</a></el-menu-item>
				<el-menu-item index="3-2"><a class="aLevelTwo" href="resource.html#/equip">Equipment Resources</a></el-menu-item>
			</el-submenu>
			<el-submenu index="4">
				<template slot="title">Performance</template>
				<el-menu-item index="4-1"><a class="aLevelTwo" href="perform.html#/oil">Offshore Oil and Gas Projects</a></el-menu-item>
				<el-menu-item index="4-2"><a class="aLevelTwo" href="perform.html#/wind">Offshore Wind Power Project</a></el-menu-item>
				<el-menu-item index="4-3"><a class="aLevelTwo" href="perform.html#/cable">Cable Laying and Maintenance</a></el-menu-item>
				<el-menu-item index="4-4"><a class="aLevelTwo" href="perform.html#/lease">Vessel Leasing Business</a></el-menu-item>
				<el-menu-item index="4-5"><a class="aLevelTwo" href="perform.html#/other">Others</a></el-menu-item>
			</el-submenu>
			<el-menu-item index="5"><a class="aLevelOne" href="news.html">News</a></el-menu-item>
			<el-menu-item index="6"><a class="aLevelOne" href="recruit.html">Recruitment</a></el-menu-item>
			<el-menu-item index="7"><a class="aLevelOne" href="contact.html">Contact</a></el-menu-item>
			<el-submenu index="8">
				<template slot="title">EN</template>
				<el-menu-item index="8-1"><a class="aLevelTwo" href="http://ds-global.cn/index.html">简体中文</a></el-menu-item>
				<el-menu-item index="8-2"><a class="aLevelTwo" href="index.html">English</a></el-menu-item>
			</el-submenu>
		</el-menu>

		<!--小屏幕-->
		<div class="navMenuSmallCon">
			<div class="navMenuSmallHead">
				<el-image class="navMenuSmallLogoImg" :src="baseImgUrl + logoImg" @click="toIndex"></el-image>
				<el-link class="navMenuSmallBtn" icon="el-icon-menu" :underline="false" @click="showNavMenuSmall = !showNavMenuSmall"></el-link>
			</div>
			<el-drawer class="navMenuSmall" size="85%" title="导航" :append-to-body="false" :visible.sync="showNavMenuSmall">
				<el-menu :default-active="curActiveIndex" class="el-menu-vertical-demo">
					<el-menu-item index="1"><span class="spanLevelOne" @click="toPage('index.html')">Home Page</span></el-menu-item>
					<el-submenu index="2">
						<template slot="title">About Us</template>
						<el-menu-item index="2-1"><span class="spanLevelTwo" @click="toPage('about.html#/intro')">Company Profile</span></el-menu-item>

						<el-submenu index="2-2">
							<template slot="title"><div class="spanTit">Organizational Structure</div></template>
							<el-menu-item index="2-6-1"><a class="spanLevelThree" @click="toPage('about.html#/org/frame')">Company structure</a></el-menu-item>
							<el-menu-item index="2-6-2"><a class="spanLevelThree" @click="toPage('about.html#/org/leader')">Leadership</a></el-menu-item>
						</el-submenu>

						<el-menu-item index="2-4"><span class="spanLevelTwo" @click="toPage('about.html#/business')">Main Business</span></el-menu-item>
						<el-menu-item index="2-5"><span class="spanLevelTwo" @click="toPage('about.html#/honor')">Qualifications and Honors</span></el-menu-item>
						<el-submenu index="2-6">
							<template slot="title"><div class="spanTit">Corporate Culture</div></template>
							<el-menu-item index="2-6-1"><span class="spanLevelThree" @click="toPage('about.html#/culture/slogan')">Company Slogan</span></el-menu-item>
							<el-menu-item index="2-6-2"><span class="spanLevelThree" @click="toPage('about.html#/culture/staff')">Staff Presence</span></el-menu-item>
							<el-menu-item index="2-6-3"><span class="spanLevelThree" @click="toPage('about.html#/culture/office')">Corporate Environment</span></el-menu-item>
							<el-menu-item index="2-6-4"><span class="spanLevelThree" @click="toPage('about.html#/culture/video')">Video Collection</span></el-menu-item>
						</el-submenu>
						<el-submenu index="2-7">
							<template slot="title"><div class="spanTit">Affiliated Agency</div></template>
							<el-menu-item index="2-7-1"><span class="spanLevelThree" @click="toPage('about.html#/branch/singapore')">Companies based in Singapore</span></el-menu-item>
							<el-menu-item index="2-7-2"><span class="spanLevelThree" @click="toPage('about.html#/branch/maritime')">Global Maritime</span></el-menu-item>
							<el-menu-item index="2-7-3"><span class="spanLevelThree" @click="toPage('about.html#/branch/equip')">Global Equipment</span></el-menu-item>
						</el-submenu>
					</el-submenu>
					<el-submenu index="3">
						<template slot="title">Resources</template>
						<el-menu-item index="3-1"><span class="spanLevelTwo" @click="toPage('resource.html#/ship')">Vessel Resources</span></el-menu-item>
						<el-menu-item index="3-2"><span class="spanLevelTwo" @click="toPage('resource.html#/equip')">Equipment Resources</span></el-menu-item>
					</el-submenu>
					<el-submenu index="4">
						<template slot="title">Performance</template>
						<el-menu-item index="4-1"><span class="spanLevelTwo" @click="toPage('perform.html#/oil')">Offshore Oil and Gas Projects</span></el-menu-item>
						<el-menu-item index="4-2"><span class="spanLevelTwo" @click="toPage('perform.html#/wind')">Offshore Wind Power Project</span></el-menu-item>
						<el-menu-item index="4-3"><span class="spanLevelTwo" @click="toPage('perform.html#/cable')">Cable Laying and Maintenance</span></el-menu-item>
						<el-menu-item index="4-4"><span class="spanLevelTwo" @click="toPage('perform.html#/lease')">Vessel Leasing Business</span></el-menu-item>
						<el-menu-item index="4-5"><span class="spanLevelTwo" @click="toPage('perform.html#/other')">Others</span></el-menu-item>
					</el-submenu>
					<el-menu-item index="5"><span class="spanLevelOne" @click="toPage('news.html')">News</span></el-menu-item>
					<el-menu-item index="6"><span class="spanLevelOne" @click="toPage('recruit.html')">Recruitment</span></el-menu-item>
					<el-menu-item index="7"><span class="spanLevelOne" @click="toPage('contact.html')">Contact Us</span></el-menu-item>
					<el-submenu index="8">
						<template slot="title">EN</template>
						<el-menu-item index="8-1"><span class="spanLevelTwo" @click="toPage('http://ds-global.cn/index.html')">简体中文</span></el-menu-item>
						<el-menu-item index="8-2"><span class="spanLevelTwo" @click="toPage('index.html')">English</span></el-menu-item>
					</el-submenu>
				</el-menu>
			</el-drawer>
		</div>
	</div>
</template>

<script>
export default {
	name: "NavMenu",
	props:[
		'activeIndex'
	],
	data() {
		return{
			baseImgUrl: process.env.VUE_APP_IMGURL,
			curActiveIndex: this.activeIndex,
			showNavMenuSmall: false,
			logoImg: 'assets/navMenu/logo_en.png'
		}
	},
	methods: {
		toIndex(){
			location.href = 'index.html';
		},
		toPage(page){
			this.showNavMenuSmall = false;
			location.href = page;
		}
	}
}
</script>
<style>
	@media (min-width: 727px){
		.el-menu--popup{ min-width: 280px !important; }
	}
</style>
<style scoped>
	.nav, a, .spanTit, .tit{ font-family: 'SiYuan-Light', sans-serif; }
	::v-deep .el-menu{ border-bottom: 0 !important;}
	a{ color: #bababa; text-decoration: none; transition: all 0.35s linear; display: block; }
	.aLevelOne:hover{ color: #4773a3 !important; }
	.aLevelTwo:hover, .aLevelThree:hover{ color: #ffffff; background-color: #4773a3; padding-left: 5px; letter-spacing: 1px; }
	@media (max-width: 726px){
		.navMenu{ display: none; }
		.navMenuSmallHead{ height: 88px; line-height: 88px; width: 100%; display: flex; justify-content: space-between; position: fixed; top: 0; background-color: #ffffff; z-index: 999; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); }
		.navMenuSmallLogoImg{ height: 52px; width: 184px; padding: 18px 0 0 8px; }
		.navMenuSmallBtn{ height: 52px; width: 52px; font-size: 20px; }
		.navMenuSmall{ font-size: 14px; }
		::v-deep .el-menu-demo .el-menu-item, ::v-deep .el-menu-demo .el-submenu__title{
			font-size: 14px; padding: 0; line-height: 40px; height: 40px; transition: all 0.2s linear; }
		.tit{ color: #354f6d; transition: all 0.35s linear; display: block; }
		.tit:hover{ color: #ffffff; background-color: #4773a3; padding-left: 5px; letter-spacing: 1px; }
		.aLevelTwo, .aLevelThree, .tit{ font-size: 14px; }
		span{ display: block; width: 100%; height: 100%; }
	}
	@media (min-width: 726px) and (max-width: 781px){
		.navMenuSmallCon{ display: none; }
		.nav{ height: 98px; width: 100%; position: fixed; top: 0; z-index: 998; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); }
		.navMenu{ height: 98px; line-height: 98px; width: 100%; display: flex; justify-content: space-between; }
		.menuLogo{ width: 192px !important; text-align: center; }
		.navLogoImg{ height: 48px; width: 158px; }
		.flex-grow{ flex-grow: 1; }
		::v-deep .el-menu-demo .el-menu-item, ::v-deep .el-menu-demo .el-submenu__title{
			height: 98px !important; line-height: 98px !important; font-size: 12px; text-align: center; transition: all 0.2s linear; padding: 0; width: 76px; margin-right: 2px; }
		::v-deep .el-menu-demo .el-menu-item:hover, ::v-deep .el-menu-demo .el-submenu__title:hover{
			border-bottom: 3px solid #354f6d !important; }
		.tit{ color: #354f6d; transition: all 0.35s linear; display: block; }
		.tit:hover{ color: #ffffff; background-color: #4773a3; padding-left: 5px; letter-spacing: 1px; }
		.aLevelTwo, .aLevelThree, .tit{ font-size: 12px; }
	}
	@media (min-width: 781px) and (max-width: 999px){
		.navMenuSmallCon{ display: none; }
		.nav{ height: 98px; width: 100%; position: fixed; top: 0; z-index: 998; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); }
		.navMenu{ height: 98px; line-height: 98px; width: 100%; display: flex; justify-content: space-between; }
		.menuLogo{ width: 192px !important; text-align: center; }
		.navLogoImg{ height: 48px; width: 158px; }
		.flex-grow{ flex-grow: 1; }
		::v-deep .el-menu-demo .el-menu-item, ::v-deep .el-menu-demo .el-submenu__title{
			height: 98px !important; line-height: 98px !important; font-size: 12px; text-align: center; transition: all 0.2s linear; padding: 0; width: 76px; margin-right: 2px; }
		::v-deep .el-menu-demo .el-menu-item:hover, ::v-deep .el-menu-demo .el-submenu__title:hover{
			border-bottom: 3px solid #354f6d !important; }
		.tit{ color: #354f6d; transition: all 0.35s linear; display: block; }
		.tit:hover{ color: #ffffff; background-color: #4773a3; padding-left: 5px; letter-spacing: 1px; }
		.aLevelTwo, .aLevelThree, .tit{ font-size: 12px; }
	}
	@media (min-width: 999px) and (max-width: 1251px){
		.navMenuSmallCon{ display: none; }
		.nav{ height: 98px; width: 100%; position: fixed; top: 0; z-index: 998; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); }
		.navMenu{ height: 98px; line-height: 98px; width: 100%; display: flex; justify-content: space-between; }
		.menuLogo{ width: 270px !important; text-align: center; }
		.navLogoImg{ height: 58px; width: 202px; }
		.flex-grow{ flex-grow: 1; }
		::v-deep .el-menu-demo .el-menu-item, ::v-deep .el-menu-demo .el-submenu__title{
			height: 98px !important; line-height: 98px !important; font-size: 15px; text-align: center; transition: all 0.2s linear; padding: 0; width: 92px; margin-right: 4px; }
		::v-deep .el-menu-demo .el-menu-item:hover, ::v-deep .el-menu-demo .el-submenu__title:hover{
			border-bottom: 3px solid #354f6d !important; }
		.tit{ color: #354f6d; transition: all 0.35s linear; display: block; }
		.tit:hover{ color: #ffffff; background-color: #4773a3; padding-left: 5px; letter-spacing: 1px; }
		.aLevelTwo, .aLevelThree, .tit{ font-size: 14px; }
	}
	@media (min-width: 1252px) and (max-width: 1759px){
		.navMenuSmallCon{ display: none; }
		.nav{ height: 98px; width: 100%; position: fixed; top: 0; z-index: 998; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); }
		.navMenu{ height: 98px; line-height: 98px; width: 100%; display: flex; justify-content: space-between; }
		.menuLogo{ width: 328px !important; text-align: center; }
		.navLogoImg{ height: 72px; width: 262px; }
		.flex-grow{ flex-grow: 1; }
		::v-deep .el-menu-demo .el-menu-item, ::v-deep .el-menu-demo .el-submenu__title{
			height: 98px !important; line-height: 98px !important; font-size: 16px; text-align: center; transition: all 0.2s linear; padding: 0; width: 120px; margin-right: 5px; }
		::v-deep .el-menu-demo .el-menu-item:hover, ::v-deep .el-menu-demo .el-submenu__title:hover{
			border-bottom: 3px solid #354f6d !important; }
		.tit{ color: #354f6d; transition: all 0.35s linear; display: block; }
		.tit:hover{ color: #ffffff; background-color: #4773a3; padding-left: 5px; letter-spacing: 1px; }
		.aLevelTwo, .aLevelThree, .tit{ font-size: 15px; }
	}
	@media (min-width: 1760px) and (max-width: 2200px){
		.navMenuSmallCon{ display: none; }
		.nav{ height: 98px; width: 100%; position: fixed; top: 0; z-index: 998; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); }
		.navMenu{ height: 98px; line-height: 98px; width: 100%; display: flex; justify-content: space-between; }
		.menuLogo{ width: 380px !important; text-align: center; }
		.navLogoImg{ height: 78px; width: 277px; }
		.flex-grow{ flex-grow: 1; }
		::v-deep .el-menu-demo .el-menu-item, ::v-deep .el-menu-demo .el-submenu__title{
			height: 98px !important; line-height: 98px !important; font-size: 17px; text-align: center; transition: all 0.2s linear; padding: 0; width: 150px; margin-right: 5px; }
		::v-deep .el-menu-demo .el-menu-item:hover, ::v-deep .el-menu-demo .el-submenu__title:hover{
			border-bottom: 3px solid #354f6d !important; }
		.tit{ color: #354f6d; transition: all 0.35s linear; display: block; }
		.tit:hover{ color: #ffffff; background-color: #4773a3; padding-left: 5px; letter-spacing: 1px; }
		.aLevelTwo, .aLevelThree, .tit{ font-size: 15px; }
	}
	@media (min-width: 2201px){
		.navMenuSmallCon{ display: none; }
		.nav{ height: 98px; width: 100%; position: fixed; top: 0; z-index: 998; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); }
		.navMenu{ height: 98px; line-height: 98px; width: 100%; display: flex; justify-content: space-between; }
		.menuLogo{ width: 422px !important; text-align: center; }
		.navLogoImg{ height: 82px; width: 284px; }
		.flex-grow{ flex-grow: 1; }
		::v-deep .el-menu-demo .el-menu-item, ::v-deep .el-menu-demo .el-submenu__title{
			height: 98px !important; line-height: 98px !important; font-size: 18px; text-align: center; transition: all 0.2s linear; padding: 0; width: 185px; margin-right: 15px; }
		::v-deep .el-menu-demo .el-menu-item:hover, ::v-deep .el-menu-demo .el-submenu__title:hover{
			border-bottom: 3px solid #354f6d !important; }
		.tit{ color: #354f6d; transition: all 0.35s linear; display: block; }
		.tit:hover{ color: #ffffff; background-color: #4773a3; padding-left: 5px; letter-spacing: 1px; }
		.aLevelTwo, .aLevelThree, .tit{ font-size: 15px; }
	}
</style>